import { createSlice } from '@reduxjs/toolkit';

export const eventSlice = createSlice({
    name: 'event',
    initialState: {
        dataToAction: { name: '', date: '', url: '' }
    },
    reducers: {
        selectEvent: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectEvent: (state) => {
            state.dataToAction = { name: '', date: '', url: '' }
        }
    }
});

export const { selectEvent, unSelectEvent } = eventSlice.actions;